import React from 'react'

import { AuthenticatedFundingAccountNestedRouter } from '../hooks'

const FundingAccountNestedRouter: React.FC = () => {
  return <AuthenticatedFundingAccountNestedRouter />
}

export { FundingAccountNestedRouter }
